import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { getProductsAll } from '../../api/products';
import { getAllMarkertName } from '../../api/market'; 
import { AddMarketData } from '../../api/marketIntelligency';
import AddMarket from './AddMarket';

const AddMarketIntelligencyModal = ({ show, handleClose }) => {
  const [loading, setLoading] = useState(false);
  const [productData, setProductData] = useState([]);
  const [isVisibleNewMarkert, setIsVisibleNewMarkert] = useState(false);
  const [marketDatas, setMarketDatas] = useState([]);
  const [error, setError] = useState("");

  const [productID, setProductID] = useState("");
  const [price, setPrice] = useState("");
  const [marketName, setMarketName] = useState("");
  const [regName, setRegName] = useState("");
  const [regMobile, setRegMobile] = useState("");
  const [date, setDate] = useState("");
  const [marketLocation, setMarketLocation] = useState("");
  const [currency, setCurrency] = useState("");

  useEffect(() => {
    setLoading(true);
    getProductsAll((result) => {
      if (result.ok !== 1) {
        console.log(result);
        return;
      }
      setProductData(result.result);
    });
    getAllMarkertName((result) => {
      if (result.ok !== 1) {
        console.log(result);
        return;
      }
      setMarketDatas(result.result);
    });
    setLoading(false);
  }, []);

  const clearForm = () => {
    setProductID("");
    setPrice("");
    setMarketName("");
    setRegName("");
    setRegMobile("");
    setDate("");
    setMarketLocation("");
    setCurrency("");
    setError("");
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setError("");

    if (!productID || !price || !marketName || !marketLocation || !regName || !regMobile || !date || !currency) {
      setError("All fields are required!");
      return;
    }

    setLoading(true);
    const MarketIntelligenceData = {
      productID,
      price,
      marketName,
      marketLocation,
      regName,
      regMobile,
      date,
      currency,
    };

    AddMarketData(MarketIntelligenceData, (result) => {
      setLoading(false);
      if (result.ok !== 1) {
        console.log(result);
        setError("Failed to save data. Please try again.");
        return;
      }
      alert("Market data saved successfully!");
      clearForm();
      handleClose();
    });
  };

  return (
    <Modal show={show} onHide={handleClose} size="lg" centered backdrop="static">
      <Modal.Header closeButton className="border-0 pb-0">
        <Modal.Title className="fw-bold text-dark">
          <i className="bi bi-graph-up me-2 text-success"></i>
          Add Market Intelligence
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-4">
        <div className="mb-3">
          <p className="text-muted mb-0">
            <i className="bi bi-info-circle me-2"></i>
            Record new market price information and intelligence data
          </p>
        </div>

        {error && (
          <div className="alert alert-danger border-0 rounded-3 d-flex align-items-center mb-4">
            <i className="bi bi-exclamation-triangle-fill me-2"></i>
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          {/* Product Selection */}
          <div className="card border-0 shadow-sm mb-4">
            <div className="card-header bg-light border-0">
              <h6 className="mb-0 fw-semibold">
                <i className="bi bi-box-seam me-2"></i>
                Product Information
              </h6>
            </div>
            <div className="card-body">
              <div className="mb-3">
                <label className="form-label fw-semibold">
                  Product Name <span className="text-danger">*</span>
                </label>
                <select
                  className="form-select form-select-lg"
                  onChange={(e) => setProductID(e.target.value)}
                  value={productID}
                  required
                  style={{ borderRadius: '8px' }}
                >
                  <option value="">Select a product...</option>
                  {productData.map((item) => (
                    <option key={item.productID} value={item.productID}>
                      {item.name} - {item.unit}
                    </option>
                  ))}
                </select>
              </div>

              <div className="row g-3">
                <div className="col-md-6">
                  <label className="form-label fw-semibold">
                    Currency <span className="text-danger">*</span>
                  </label>
                  <select 
                    onChange={(e) => setCurrency(e.target.value)} 
                    value={currency} 
                    className="form-select"
                    required
                    style={{ borderRadius: '8px' }}
                  >
                    <option value="">Select currency...</option>
                    <option value="TSH">TSH - Tanzanian Shilling</option>
                    <option value="KSH">KSH - Kenyan Shilling</option>
                    <option value="UGX">UGX - Ugandan Shilling</option>
                    <option value="USD">USD - US Dollar</option>
                  </select>
                </div>
                <div className="col-md-6">
                  <label className="form-label fw-semibold">
                    Price <span className="text-danger">*</span>
                  </label>
                  <input
                    type="number"
                    onChange={(e) => setPrice(e.target.value)}
                    value={price}
                    placeholder="Enter price"
                    className="form-control"
                    required
                    min="0"
                    step="0.01"
                    style={{ borderRadius: '8px' }}
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Market Information */}
          <div className="card border-0 shadow-sm mb-4">
            <div className="card-header bg-light border-0">
              <h6 className="mb-0 fw-semibold">
                <i className="bi bi-geo-alt me-2"></i>
                Market Information
              </h6>
            </div>
            <div className="card-body">
              <div className="mb-3">
                {isVisibleNewMarkert ? (
                  <AddMarket
                    setIsVisibleNewMarkert={setIsVisibleNewMarkert}
                    setMarketDatas={setMarketDatas}
                  />
                ) : (
                  <div>
                    <label className="form-label fw-semibold">
                      Market Name <span className="text-danger">*</span>
                    </label>
                    <div className="input-group">
                      <select
                        className="form-select"
                        onChange={(e) => setMarketName(e.target.value)}
                        value={marketName}
                        required
                        style={{ borderRadius: '8px 0 0 8px' }}
                      >
                        <option value="">Select market...</option>
                        {marketDatas.map((item, index) => (
                          <option key={index} value={item.name}>{item.name}</option>
                        ))}
                      </select>
                      <button
                        className="btn btn-outline-primary"
                        type="button"
                        onClick={() => setIsVisibleNewMarkert(true)}
                        style={{ borderRadius: '0 8px 8px 0' }}
                      >
                        <i className="bi bi-plus-lg"></i>
                      </button>
                    </div>
                  </div>
                )}
              </div>

              <div className="mb-3">
                <label className="form-label fw-semibold">
                  Market Location <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  onChange={(e) => setMarketLocation(e.target.value)}
                  value={marketLocation}
                  placeholder="Enter market location"
                  className="form-control"
                  required
                  style={{ borderRadius: '8px' }}
                />
              </div>

              <div className="mb-3">
                <label className="form-label fw-semibold">
                  Date <span className="text-danger">*</span>
                </label>
                <input
                  type="date"
                  onChange={(e) => setDate(e.target.value)}
                  value={date}
                  className="form-control"
                  required
                  style={{ borderRadius: '8px' }}
                />
              </div>
            </div>
          </div>

          {/* Registration Information */}
          <div className="card border-0 shadow-sm mb-4">
            <div className="card-header bg-light border-0">
              <h6 className="mb-0 fw-semibold">
                <i className="bi bi-person-badge me-2"></i>
                Registration Information
              </h6>
            </div>
            <div className="card-body">
              <div className="row g-3">
                <div className="col-md-6">
                  <label className="form-label fw-semibold">
                    Full Name <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    onChange={(e) => setRegName(e.target.value)}
                    value={regName}
                    placeholder="Enter full name"
                    className="form-control"
                    required
                    style={{ borderRadius: '8px' }}
                  />
                </div>
                <div className="col-md-6">
                  <label className="form-label fw-semibold">
                    Mobile Number <span className="text-danger">*</span>
                  </label>
                  <input
                    type="tel"
                    onChange={(e) => setRegMobile(e.target.value)}
                    value={regMobile}
                    placeholder="Enter mobile number"
                    className="form-control"
                    required
                    style={{ borderRadius: '8px' }}
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Action Buttons */}
          <div className="d-flex justify-content-end gap-3">
            <button
              type="button"
              className="btn btn-secondary px-4"
              onClick={handleClose}
              disabled={loading}
              style={{ borderRadius: '8px' }}
            >
              <i className="bi bi-x-circle me-2"></i>
              Cancel
            </button>
            <button
              type="submit"
              className="btn btn-success px-4"
              disabled={loading}
              style={{ borderRadius: '8px' }}
            >
              {loading ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2"></span>
                  Saving...
                </>
              ) : (
                <>
                  <i className="bi bi-check-circle me-2"></i>
                  Save Market Data
                </>
              )}
            </button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

export default AddMarketIntelligencyModal;